import { FeedbackMetadataGrid } from '@modules/feedback/components/FeedbackMetadata';
import { FeedbackMetadataField } from '@modules/feedback/types';
import { trackFeedbackMetadataEvent } from '@modules/feedback/utils';
import { KeyboardArrowDownRounded } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import { ObjectType } from 'generated/graphql';
import { useState } from 'react';

interface FeedbackMetadataAccordionProps {
  title: string;
  metadataFields: FeedbackMetadataField[];
  gridColumns?: number;
  feedbackID: string;
  objectType: ObjectType;
}

export const FeedbackMetadataAccordion = ({
  title,
  metadataFields,
  gridColumns,
  feedbackID,
  objectType,
}: FeedbackMetadataAccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleAccordionChange = (
    _: React.SyntheticEvent<Element, Event>,
    isExpanded: boolean,
  ) => {
    setIsExpanded(isExpanded);
    if (isExpanded) {
      trackFeedbackMetadataEvent({
        eventName:
          'Feedback Metadata - Expanded Metadata Card Grouped By Identifier',
        feedbackID,
        objectType,
      });
    }
  };

  return (
    <Box>
      <Accordion
        elevation={0}
        disableGutters
        expanded={isExpanded}
        onChange={handleAccordionChange}
        sx={{
          bgcolor: 'transparent',
        }}
      >
        <AccordionSummary
          sx={{
            px: 0.5,
          }}
          expandIcon={<KeyboardArrowDownRounded />}
        >
          <Typography variant="body2">{title}</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            px: 0.7,
          }}
        >
          <FeedbackMetadataGrid
            disablePadding
            shouldLimitGridItems={false}
            metadataFields={metadataFields}
            gridColumns={gridColumns}
            feedbackID={feedbackID}
            objectType={objectType}
          />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
